import React from 'react';
import { motion } from 'framer-motion';
import { ComparisonTableSlide as ComparisonTableSlideType } from '../../types';
import { SlideContainer, SlideTitle } from '../common/SlideComponents';

interface ComparisonTableSlideProps {
  content: ComparisonTableSlideType;
  title?: string;
  speakerNotes?: string;
}

export const ComparisonTableSlide: React.FC<ComparisonTableSlideProps> = ({
  content,
  title,
  speakerNotes
}) => {
  return (
    <SlideContainer>
      <div className="flex flex-col h-full">
        {title && (
          <SlideTitle className="text-5xl mb-16 text-center">
            {title}
          </SlideTitle>
        )}
        
        <div className="flex-1 flex items-center justify-center">
          <motion.div
            className="healthcare-card p-12 max-w-6xl w-full"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="overflow-hidden">
              <table className="w-full">
                <thead>
                  <tr className="border-b-2 border-warm-gray/20">
                    {content.headers.map((header, index) => (
                      <motion.th
                        key={index}
                        className="text-left py-6 px-6 text-2xl font-semibold text-deep-slate"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                      >
                        {header}
                      </motion.th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {content.rows.map((row, rowIndex) => (
                    <motion.tr
                      key={rowIndex}
                      className="border-b border-warm-gray/10 hover:bg-gray-50/50 transition-colors duration-200"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 0.5 + rowIndex * 0.1 }}
                    >
                      <td className="py-6 px-6 font-medium text-soft-black text-lg">
                        {row.label}
                      </td>
                      {row.values.map((value, valueIndex) => (
                        <td key={valueIndex} className="py-6 px-6 text-lg text-warm-gray">
                          {value}
                        </td>
                      ))}
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>
      </div>
      
      {speakerNotes && (
        <div className="absolute bottom-4 left-4 opacity-0 hover:opacity-100 transition-opacity duration-200">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-3 text-sm text-warm-gray max-w-xs">
            <strong>Speaker Notes:</strong> {speakerNotes}
          </div>
        </div>
      )}
    </SlideContainer>
  );
};